import { AppConsts } from "@shared/AppConsts";
import * as moment from "moment";

export class AppCommon {
  public static ConvertToUnSign(str) {
    if (str != null && str != undefined && str != '') {
      str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
      str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
      str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
      str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
      str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
      str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
      str = str.replace(/đ/g, "d");
      str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
      str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
      str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
      str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
      str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
      str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
      str = str.replace(/Đ/g, "D");
      // Combining Diacritical Marks
      str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // huyền, sắc, hỏi, ngã, nặng
      str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // mũ â (ê), mũ ă, mũ ơ (ư)

      return str;
    }
    return "";
  }

  public static GetFormatDate() {
    if (AppConsts.IsDefaultFormatDate) {
      return AppConsts.DefaultFormatDate;
    }

    return AppConsts.FormatDate.ShortDate.find(
      (s) => s.locale == abp.localization.currentLanguage.name
    ).display.toUpperCase();
  }

  public static ConvertNumberToDate(value) {
    if (value === null) {
      return value;
    }

    const day = value % 100;
    value = Math.trunc(value / 100);

    const month = (value % 100) - 1;
    value = Math.trunc(value / 100);

    const year = value;

    return moment([year, month, day]);
  }

  public static ConvertDateToString(value) {
    if (value === null || value === undefined) {
      return null;
    }

    let dayString = "";
    let monthString = "";

    const year = value.get("year");

    const month = value.get("month") + 1;

    const day = value.get("date");

    dayString = day < 10 ? `0${day}` : `${day}`;

    monthString = month < 10 ? `0${month}` : `${month}`;

    return `${year}${monthString}${dayString}`;
  }

  public static ConvertNumberToDateString(value) {
    if (value === null || value === undefined) {
      return "";
    }

    let valueTemp = value;
    let dayString = "";
    let monthString = "";

    const day = valueTemp % 100;
    valueTemp = Math.trunc(value / 100);

    const month = valueTemp % 100;
    valueTemp = Math.trunc(valueTemp / 100);

    const year = valueTemp;

    dayString = day < 10 ? `0${day}` : `${day}`;

    monthString = month < 10 ? `0${month}` : `${month}`;

    return AppConsts.DefaultFormatDate.replace("DD", dayString)
      .replace("MM", monthString)
      .replace("YYYY", `${year}`);
  }

  public static FormatLabelLength(str: string, length: number) {
    if (str != null) {
      if (str.length > 50) {
        str = str.slice(0, 50) + "...";
      }
    }
    return str;
  }

  public static FormatLabelForChart(str: string, maxwidth: number) {
    let sections = [];
    let words = str.split(" ");
    let temp = "";
    words.forEach(function (item, index) {
      if (temp.length > 0) {
        let concat = temp + " " + item;
        if (concat.length > maxwidth) {
          sections.push(temp);
          temp = "";
        } else {
          if (index == words.length - 1) {
            sections.push(concat);
            return;
          } else {
            temp = concat;
            return;
          }
        }
      }
      if (index == words.length - 1) {
        sections.push(item);
        return;
      }
      if (item.length < maxwidth) {
        temp = item;
      } else {
        sections.push(item);
      }
    });
    return sections;
  }
}
